module.exports = __webpack_public_path__ + "static/media/check.444c6663.svg";